import { FiLayout } from 'react-icons/fi';
import { GiReceiveMoney } from 'react-icons/gi';
import { IoLogoBitcoin } from 'react-icons/io';



import Navbar from "../../../components/navbar";
import HomeContent from '../../../components/homeContent';
import Footer from "../../../components/footer";

import Phone from '../../../assets/img/phone.png';


const Home = () =>{
  return(
    <>
    <header
    className="container-fluid bg-primary header1"
    id="home">
      <div className="container">
        <Navbar />
        <div className="d-flex flex-column flex-lg-row">
          <div className="col-12 col-lg-7 my-5 my-lg-0">
            <div className="h-50" />
            <h1 className="text-white display-4 font-weight-bolder ">
              Create awesome landing pages with Bang!
            </h1>
            <button className="btn btn-secondary btn-lg mt-2">
              getting started
            </button>
          </div>
          <div className="col-10 col-lg-4 offset-0 offset-xl-1 d-flex align-self-center align-self-lg-start position-relative d-lg-block justify-content-center mt-5">
            <img
            src={Phone}
            alt="..."
            className="position-absolute top-100 start-0 translate-middle img-fluid" 
            />
          </div>
        </div>
      </div>
    </header>
    <div
    className="container division"
    id="features">
      <h1 className="title-responsive text-center">
        Bang App features
      </h1>
      <div className="division2 d-flex justify-content-center flex-wrap text-primary">
        <div className="col-12 col-md-6 d-flex justify-content-center mt-2 mt-lg-0 p-0 p-lg-3">
          <div className="box shadow w-100 row align-items-center justify-content-around">
            <FiLayout
            className="col-6 col-md-5"
            size="100%"
            />
            <h2 className="col-6 p-0 font-weight-bold">
              mordern interface
            </h2>
          </div>
        </div>
        <div className="col-12 col-md-6 d-flex justify-content-center p-0 p-lg-3 mt-2 mt-lg-0">
          <div className="box shadow w-100 d-flex align-items-center justify-content-around">
            <GiReceiveMoney
            className="col-6 col-md-5"
            size="100%"
            />
            <h2 className="col-6 p-0 font-weight-bold">
              payment with pix
            </h2>
          </div>
        </div>
        <div className="col-12 col-md-6 d-flex justify-content-center p-0 p-lg-3 mt-2 mt-lg-0">
          <div className="box shadow w-100 d-flex align-items-center justify-content-around">
            <IoLogoBitcoin
            className="col-6 col-md-5"
            size="100%"
            />
            <h2 className="col-6 p-0 font-weight-bold">
              payment with BTC
            </h2>
          </div>
        </div>
        <div className="col-12 col-md-6 d-flex justify-content-center p-0 p-lg-3 mt-2 mt-lg-0">
          <div className="box shadow w-100 d-flex align-items-center justify-content-around">
            <FiLayout
            className="col-6 col-md-5"
            size="100%"
            />
            <h2 className="col-6 p-0 font-weight-bold">
              mordern interface
            </h2>
          </div>
        </div>
        <div className="col-12 col-md-6 d-flex justify-content-center p-0 p-lg-3 mt-2 mt-lg-0">
          <div className="box shadow w-100 d-flex align-items-center justify-content-around">
            <GiReceiveMoney
            className="col-6 col-md-5"
            size="100%"
            />
            <h2 className="col-6 p-0 font-weight-bold">
              payment with pix
            </h2>
          </div>
        </div>
        <div className="col-12 col-md-6 d-flex justify-content-center p-0 p-lg-3 mt-2 mt-lg-0">
          <div className="box shadow w-100 d-flex align-items-center justify-content-around">
            <IoLogoBitcoin
            className="col-6 col-md-5"
            size="100%"
            />
            <h2 className="col-6 p-0 font-weight-bold">
              payment with BTC
            </h2>
          </div>
        </div>
      </div>
    </div>
    <HomeContent />
    <Footer />
    </>
  )
};
export default Home;